// Frontend copy of the Motion Reality sim rig disclaimer text.
// Mirrors base44/shared/disclaimerText.ts (used by the sendDisclaimerCopy
// backend function for the PDF attachment) so the on-screen form and the
// emailed PDF always show the same terms.

export const DISCLAIMER_SECTIONS = [
  {
    title: '1. Intended Use',
    body: 'This product is designed solely for simulated racing experiences. It is not a substitute for real-world driving instruction or professional racing training.',
  },
  {
    title: '2. Health & Safety Guidance',
    bullets: [
      'Users should be in reasonable physical fitness and free from conditions aggravated by motion, flashing imagery or sustained posture.',
      'Stop immediately if you experience dizziness, nausea, blurred vision, disorientation or discomfort, and rest before resuming.',
      'Do not use the rig if you have a history of epilepsy, seizures, heart conditions, or musculoskeletal issues without first consulting a medical professional.',
      'Take regular breaks to reduce eye strain and fatigue; rest your eyes and hydrate frequently.',
    ],
  },
  {
    title: '3. Operation',
    bullets: [
      'Do not modify, adjust or disassemble any rig hardware without staff supervision.',
      'No food or liquids are permitted on or near the rig at any time.',
    ],
  },
  {
    title: '4. Age Restrictions',
    body: 'Recommended for users aged 16 years and above. Children under 16 must be supervised by an adult at all times.',
  },
  {
    title: '5. Liability & Consumer Rights',
    body: 'Motion Reality accepts no liability for injury, loss or damage arising from misuse, unsupervised use, or incorrect installation. Your statutory rights are protected under the Consumer Rights Act 2015.',
  },
  {
    title: '6. Risk of Virtual Environment',
    body: 'Prolonged use of simulated motion environments may cause fatigue or motion sickness. Take breaks every 20–30 minutes, ensure adequate ventilation, and stop if you feel unwell.',
  },
  {
    title: '7. Data Privacy & GDPR Compliance',
    body: 'Your details are handled in accordance with UK GDPR and the Data Protection Act 2018. You have the right to access, correct or request deletion of your data. For any data requests, contact sales@motionreality.co.uk.',
  },
];